import { doc, setDoc } from "firebase/firestore";
import db, { realTimeDB } from "../firebase";
import {
  LivestreamLayout,
  StreamCall,
  StreamVideo,
  StreamVideoClient,
} from "@stream-io/video-react-sdk";
import { useState } from "react";
import ReactLinkify from "react-linkify";
import { format } from "date-fns";
import { get, ref, remove, set } from "firebase/database";
import { ConstVariables } from "../newComponents2/ConstantVariables";

export const SendPost = (
  postID,
  utcTime,
  blogText,
  imageLinks,
  videoLink,
  thumbnailLink,
  userName,
  profile_pic,
  user_email,
  bloggerid,
  timestamp,
) => {
  return new Promise(async (resolve, reject) => {
    try {
      await setDoc(doc(db, ConstVariables.BLOG_POST, postID), {
        postID,
        blog_date: utcTime,
        blog_message: blogText,
        images: imageLinks.length < 0 ? "" : imageLinks,
        video_url: videoLink,
        video_thumb: thumbnailLink,
        blogger_name: userName,
        blogger_profile_pic: profile_pic,
        blogger_email: user_email,
        bloggerpageid: bloggerid,
        timestamp,
      });
      resolve(true);
    } catch (error) {
      reject(error);
    }
  });
};

export const ShortenText = (fullText, wordsLimit) => {
  const words = fullText.trim().split(" ");
  if (words.length > wordsLimit) {
    const truncText = `${words.slice(0, wordsLimit).join(" ")} ...`;
    return truncText;
  } else {
    return fullText;
  }
};

export const formatMediaTime = (seconds) => {
  const hrs = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60);

  return `${hrs >= 1 ? hrs.toString().padStart(2, "0") : ""} ${mins
    .toString()
    .padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
};

export const reverseMediaTimeToSeconds = (time) => {
  const timerParts = time.split(":").map(Number);
  let hrs = 0,
    mins = 0,
    secs = 0;

  if (timerParts.length === 3) {
    [hrs, mins, secs] = timerParts;
  } else if (timerParts.length === 2) {
    [mins, secs] = timerParts;
  } else if (timerParts.length === 1) {
    [secs] = timerParts;
  }

  return hrs * 3600 + mins * 60 + secs;
};

export const ItemID = () => {
  return format(new Date(), "yyyyMMddHHmmss");
};

export const SendShortsPost = async (
  shorts_id,
  shorts_date,
  shorts_vid,
  shorts_thumbnail,
  shorts_text,
  shorts_desc,
  shorts_name,
  shorts_profile,
  shorts_email,
  timestamp,
  year,
  bloggerid,
) => {
  return new Promise(async (resolve, reject) => {
    try {
      await setDoc(doc(db, ConstVariables.SHORTS_POST, shorts_id), {
        shorts_id: shorts_id,
        shorts_date: shorts_date,
        shorts_vid: shorts_vid,
        shorts_thumbnail: shorts_thumbnail,
        shorts_text: shorts_text,
        userOwnPic: "",
        shorts_desc: shorts_desc,
        shorts_name: shorts_name,
        shorts_profile: shorts_profile,
        shorts_email: shorts_email,
        timestamp,
        year: year,
      });
      resolve(true);
    } catch (error) {
      reject(error);
    }
  });
};

export const SendLiveComment = (
  docID,
  userName,
  bloggerid,
  message,
  profile_pic,
  emoji,
  timestamp,
  date,
) => {
  return new Promise(async (resolve, reject) => {
    try {
      await setDoc(doc(db, "liveComments", docID), {
        docID,
        userName,
        userID: bloggerid,
        message: message,
        userPic: profile_pic,
        emoji: emoji,
        timestamp,
        date,
      });
      resolve(true);
    } catch (error) {
      reject(error);
    }
  });
};

export const formatNumber = (num) => {
  // const options = {
  //     maximumFractionDigits: 2,
  //     minimumFractionDigits: 2
  //   };

  if (num >= 1000000) {
    // return new Intl.NumberFormat('en-US', options).format(num / 1000000) + 'm';
    return (
      (num % 1000000 === 0
        ? Math.floor(num / 1000000)
        : (num / 1000000).toFixed(2)) + "m"
    );
  } else if (num >= 1000) {
    return (
      (num % 1000 === 0 ? Math.floor(num / 1000) : (num / 1000).toFixed(1)) +
      "k"
    );
    // return new Intl.NumberFormat('en-US', options).format(num / 1000) + 'k';
  } else {
    return String(num);
  }
};

const ViewWebWebRTC = ({ token, apiKey }) => {
  const userId = "horemow_media";
  const callid = `horemowmediahbrlive`;
  // const {profile_pic} = useContext(AuthContext);
  // const {userName} = useContext(AuthContext);
  const alphabets = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const randomName = `hbrUser${Math.floor(
    Math.random() * 10000,
  )}${alphabets.charAt(Math.floor(Math.random() * alphabets.length))}`;

  const user = {
    id: userId,
    name: randomName,
    image:
      "https://firebasestorage.googleapis.com/v0/b/holiness-revival-movement.appspot.com/o/user_profile%2FHBRsoftTeam%20?alt=media&token=98249e06-eca2-42c4-9154-32d5064da537",
  };

  const client = new StreamVideoClient({ apiKey, user, token });
  const call = client.call("livestream", callid);
  call.camera.disable();
  call.microphone.disable();
  call.join();

  return (
    <StreamVideo client={client}>
      <StreamCall call={call}>
        <LivestreamLayout
          showParticipantCount={false}
          showDuration={false}
          showLiveBadge={false}
        />
      </StreamCall>
    </StreamVideo>
  );
};
export default ViewWebWebRTC;

export const FormatTimePassedUtc = (timestamp) => {
  const date =
    typeof timestamp === "number" ? new Date(timestamp) : timestamp.toDate();
  const now = new Date();
  const secondsPast = (now.getTime() - date.getTime()) / 1000;

  if (secondsPast < 0) {
    return "";
  }

  if (secondsPast < 60) {
    return (
      parseInt(secondsPast) +
      " sec" +
      (parseInt(secondsPast) > 1 ? "" : "") +
      " ago"
    );
  }
  if (secondsPast < 3600) {
    return (
      parseInt(secondsPast / 60) +
      " min" +
      (parseInt(secondsPast / 60) > 1 ? "" : "") +
      " ago"
    );
  }
  if (secondsPast <= 86400) {
    return (
      parseInt(secondsPast / 3600) +
      " hr" +
      (parseInt(secondsPast / 3600) > 1 ? "s" : "") +
      " ago"
    );
  }
  if (secondsPast > 86400 && secondsPast <= 2592000) {
    const day = parseInt(secondsPast / 86400);
    const week = parseInt(day / 7);
    return week > 0
      ? week + " wk" + (week > 1 ? "s" : "") + " ago"
      : day + " day" + (day > 1 ? "s" : "") + " ago";
  }
  if (secondsPast > 2592000 && secondsPast <= 31536000) {
    const month = parseInt(secondsPast / 2592000);
    return month + " mth" + (month > 1 ? "" : "") + " ago";
  }
  if (secondsPast > 31536000) {
    const year = parseInt(secondsPast / 31536000);
    return year + " yr" + (year > 1 ? "s" : "") + " ago";
  }
};

export const TextShortenerConfig = ({ fullText, words }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const fullTextArray = fullText.split(" ");
  const shortText = `${fullText.split(" ").slice(0, words).join(" ")}`;

  const linkDecorator = (href, text, key) => (
    <a
      style={{ color: "#0251EB", textDecoration: "none" }}
      href={href}
      key={key}
      target="_blank"
      rel="noopener noreferrer"
    >
      {text}
    </a>
  );

  return (
    <pre>
      <ReactLinkify componentDecorator={linkDecorator}>
        {isExpanded ? fullText : shortText}
        {fullTextArray && fullTextArray.length > words && (
          <button
            id="textheightcontrolbtn"
            onClick={() => setIsExpanded((prev) => !prev)}
          >
            {isExpanded ? "   read Less" : "...read more"}
          </button>
        )}
      </ReactLinkify>
    </pre>
  );
};

export const extractVideoId = (url) => {
  const regex =
    /(?<=watch\?v=|\/videos\/|embed\/|youtu.be\/|\/v\/|\/e\/|watch\?v%3D|watch\?feature=player_embedded&v=|%2Fvideos%2F|embed%3F|youtu.be%2F|%2Fv%2F|\/live\/)[^#&?\\n]*/;
  const match = url.match(regex);
  const videoId = match ? match[0] : null;
  return videoId;
};

export const sanitizeText = (textUtils) => {
  if (textUtils) {
    const regex = /[^a-z0-9]/gi;
    return textUtils.replace(regex, "");
  } else {
    return "";
  }
};

export const getMediaStoragePath = (url) => {
  const regex = /o\/(.*?)\?/;
  const match = url.match(regex);
  const lastpath = match ? match[1] : null;
  return lastpath.replace(/%2F/g, "/");
};

export const PurifyTextUtils = (textUtils) => {
  if (textUtils) {
    const regex = /[.#$[\]]/gi;
    return textUtils.replace(regex, "");
  } else {
    return "";
  }
};

export const customFuzzySearch = (searchWord, searchList) => {
  let THRESHOLD = 30;
  let results = [];

  searchList.forEach((lookupValue) => {
    const distance = LavensteinAlgorithm(searchWord, lookupValue.searchItem);
    if (distance <= THRESHOLD) {
      results.push({ lookupValue, distance });
    }
  });
  results.sort((a, b) => a.distance - b.distance);
  return results.map((result) => result.lookupValue);
};

export const LavensteinAlgorithm = (a, b) => {
  a = a
    .toLowerCase()
    .trim()
    .replace(/\s+/g, "")
    .replace(/[^\w\s]|_/g, "");
  b = b
    .toLowerCase()
    .trim()
    .replace(/\s+/g, "")
    .replace(/[^\w\s]|_/g, "");
  const dp = Array.from({ length: a.length + 1 }, () =>
    Array(b.length + 1).fill(0),
  );
  for (let i = 0; i <= a.length; i++) {
    for (let j = 0; j <= b.length; j++) {
      if (i === 0) {
        dp[i][j] = j;
      } else if (j === 0) {
        dp[i][j] = i;
      } else {
        dp[i][j] = Math.min(
          dp[i - 1][j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1),
          Math.min(dp[i - 1][j] + 1, dp[i][j - 1] + 1),
        );
      }
    }
  }
  return dp[a.length][b.length];
};

export const shareBlogPost = async (blogger_name, postID) => {
  if (navigator.share) {
    try {
      await navigator.share({
        title: "Divine blogs",
        text: `Post from ${blogger_name}`,
        url: `https://horemowbookreaderlite.web.app/divineblog/${postID}`,
      });
      handleRealtimeDataChanges(ConstVariables.SHARES, postID);
    } catch {}
  }
};
export const shareHelper = async (title, text, url) => {
  if (navigator.share) {
    try {
      await navigator.share({
        title: title,
        text: text,
        url: url,
      });
    } catch {}
  }
};

export const removePostAnalytics = (postID) => {
  remove(ref(realTimeDB, `Reactions/${postID}`));
};

export const handleRealtimeDataChanges = async (actionType, postID) => {
  const valueRef = await get(
    ref(realTimeDB, `Reactions/${postID}/${actionType}`),
  );
  if (valueRef.exists()) {
    if (valueRef.val() === 0) {
      set(ref(realTimeDB, `Reactions/${postID}/${actionType}`), 1);
    } else {
      set(
        ref(realTimeDB, `Reactions/${postID}/${actionType}`),
        valueRef.val() + 1,
      );
    }
  } else {
    set(ref(realTimeDB, `Reactions/${postID}/${actionType}`), 1);
  }
};

export const handleDecreaseEdifiedCount = async (postID) => {
  const valueRef = await get(ref(realTimeDB, `Reactions/${postID}/edified`));
  if (valueRef.exists()) {
    if (valueRef.val() === 0) {
      set(ref(realTimeDB, `Reactions/${postID}/edified`), 0);
    } else {
      set(ref(realTimeDB, `Reactions/${postID}/edified`), valueRef.val() - 1);
    }
  }
};
export const handleDecreaseCommentCount = async (postID) => {
  const valueRef = await get(ref(realTimeDB, `Reactions/${postID}/comments`));
  if (valueRef.exists()) {
    if (valueRef.val() === 0) {
      set(ref(realTimeDB, `Reactions/${postID}/comments`), 0);
    } else {
      set(ref(realTimeDB, `Reactions/${postID}/comments`), valueRef.val() - 1);
    }
  }
};

export const insertBookAnalytics = async (
  bookTitle = "",
  analyticsType = "",
  numOfStars,
) => {
  if (bookTitle && bookTitle.trim() && analyticsType && analyticsType.trim()) {
    const analyticsRef = await get(
      ref(
        realTimeDB,
        `bookStats/${PurifyTextUtils(bookTitle)}/${analyticsType}`,
      ),
    );
    if (analyticsRef.exists()) {
      if (analyticsType === ConstVariables.RATE) {
        if (analyticsRef.val() === 0) {
          set(
            ref(
              realTimeDB,
              `bookStats/${PurifyTextUtils(bookTitle)}/${analyticsType}`,
            ),
            numOfStars,
          );
        } else {
          set(
            ref(
              realTimeDB,
              `bookStats/${PurifyTextUtils(bookTitle)}/${analyticsType}`,
            ),
            analyticsRef.val() + numOfStars,
          );
        }
      } else {
        if (analyticsRef.val() === 0) {
          set(
            ref(
              realTimeDB,
              `bookStats/${PurifyTextUtils(bookTitle)}/${analyticsType}`,
            ),
            1,
          );
        } else {
          set(
            ref(
              realTimeDB,
              `bookStats/${PurifyTextUtils(bookTitle)}/${analyticsType}`,
            ),
            analyticsRef.val() + 1,
          );
        }
      }
    } else {
      if (analyticsType === ConstVariables.RATE) {
        set(
          ref(
            realTimeDB,
            `bookStats/${PurifyTextUtils(bookTitle)}/${analyticsType}`,
          ),
          numOfStars,
        );
      } else {
        set(
          ref(
            realTimeDB,
            `bookStats/${PurifyTextUtils(bookTitle)}/${analyticsType}`,
          ),
          1,
        );
      }
    }
  }
};

export const insertAudioBookAnalytics = async (
  bookTitle,
  analyticsType,
  numOfStars,
) => {
  const analyticsRef = await get(
    ref(
      realTimeDB,
      `audioBookStats/${
        PurifyTextUtils(bookTitle) + " - Audio book 🎧"
      }/${analyticsType}`,
    ),
  );
  if (analyticsRef.exists()) {
    if (analyticsType === ConstVariables.RATE) {
      if (analyticsRef.val() === 0) {
        set(
          ref(
            realTimeDB,
            `audioBookStats/${
              PurifyTextUtils(bookTitle) + " - Audio book 🎧"
            }/${analyticsType}`,
          ),
          numOfStars,
        );
      } else {
        set(
          ref(
            realTimeDB,
            `audioBookStats/${
              PurifyTextUtils(bookTitle) + " - Audio book 🎧"
            }/${analyticsType}`,
          ),
          analyticsRef.val() + numOfStars,
        );
      }
    } else {
      if (analyticsRef.val() === 0) {
        set(
          ref(
            realTimeDB,
            `audioBookStats/${
              PurifyTextUtils(bookTitle) + " - Audio book 🎧"
            }/${analyticsType}`,
          ),
          1,
        );
      } else {
        set(
          ref(
            realTimeDB,
            `audioBookStats/${
              PurifyTextUtils(bookTitle) + " - Audio book 🎧"
            }/${analyticsType}`,
          ),
          analyticsRef.val() + 1,
        );
      }
    }
  } else {
    if (analyticsType === ConstVariables.RATE) {
      set(
        ref(
          realTimeDB,
          `audioBookStats/${
            PurifyTextUtils(bookTitle) + " - Audio book 🎧"
          }/${analyticsType}`,
        ),
        numOfStars,
      );
    }
    set(
      ref(
        realTimeDB,
        `audioBookStats/${
          PurifyTextUtils(bookTitle) + " - Audio book 🎧"
        }/${analyticsType}`,
      ),
      1,
    );
  }
};

export const DisplayUserPicAndName = async (email) => {
  if (email) {
    const userRefSnapshot = await get(
      ref(realTimeDB, `User Account/${sanitizeText(email)}`),
    );
    if (userRefSnapshot.exists()) {
      const nameFromDB = userRefSnapshot.child("userName").val();
      const userPicture = userRefSnapshot.child("profile_pic").val();
      const bio = userRefSnapshot.child("bio").val();
      const email = userRefSnapshot.child("user_email").val();

      return {
        name: nameFromDB && nameFromDB !== "" ? nameFromDB : "",
        profilePic: userPicture ? userPicture : "",
        bio: bio ? bio : "",
        userEmail: email ? email : "",
      };
    } else {
      return {
        name: "",
        profilePic: "",
        bio: "",
        userEmail: "",
      };
    }
  } else {
    return {
      name: "",
      profilePic: "",
      bio: "",
      userEmail: "",
    };
  }
};

//TODO: ADD CREATE POST TO YOUR OWN PROFLE PAGE
//Create a general sharing component
